import styled from "styled-components";

export const InfoTitle = styled.div`
    width: 100px;
    text-align: right;
    font-weight: bold;
    padding: 4px
`;

export const InfoItem = styled.div`
    padding: 4px;
`;

export const InfoContainer = styled.div`
    margin-top: 1.25rem;
`;

export const InfoContainerTitle = styled.div`
    font-size: 20px;
`;

export const ContainerTitle = styled.div`
    font-size: 24px;
`;

export const RentalInfo = styled.div`
    display: flex;
    align-content: center;
    gap: 1rem;
    border-top: solid 1px #d1d5db;
    padding: 5px 0;
`;

export const SubContainer = styled.div`
    border: 1px solid #d1d5db;
    padding: 1rem;
`;

export const CustomTable = styled.table`
        table-layout: fixed; 
        width: 100%; 
        border-collapse: collapse;
        margin-top: 7px;
        margin-bottom: 10px;
    `;

export const CustomTh = styled.th`
        border: 1px solid #e5e5e5;
        text-align: ${(props) => props.align || 'center'};
        width: 10px;
        background: ${(props) => props.background || '#ffffff'};
        padding: ${(props) => props.padding || '5px 0px'};
    `;

export const CustomTd = styled.td`
        border: 1px solid #e5e5e5;
        text-align: left;
        width: 20px;
        padding: 10px 0 10px 1.5rem;
        overflow: hidden; 
        white-space: nowrap;
        text-overflow: ellipsis;
    `;